import { BaseApiService } from './BaseApiService';

class SlotService extends BaseApiService {
  async getAllSlots() {
    try {
      console.log('Making API call to get all slots...');
      const response = await this.api.get('/get-slots');
      console.log('Get all slots response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Get all slots error:', error);
      throw error;
    }
  }

  // For interviewer to get all booked slots with pagination
  async getAllSlotsForInterviewer(page = 1, perPage = 10) {
    try {
      console.log(`Making API call to get all slots for interviewer (page: ${page}, per_page: ${perPage})...`);
      const response = await this.api.get(`/get-all-slots?page=${page}&per_page=${perPage}`);
      console.log('Get all slots for interviewer response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Get all slots for interviewer error:', error);
      throw error;
    }
  }

  async selectSlot(slotData) {
    try {
      const response = await this.api.post('/v1/slot-selection', slotData);
      return response.data;
    } catch (error) {
      console.error('Slot selection error:', error);
      throw error;
    }
  }

  // Get slot counts for interviewer dashboard
  async getSlotCounts() {
    try {
      console.log('Making API call to get slot counts...');
      const response = await this.api.get('/count-all-slots');
      console.log('Get slot counts response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Get slot counts error:', error);
      throw error;
    }
  }

  // Get slots for a specific interviewer (POST API)
  async getSlotsByInterviewer(interviewerId) {
    try {
      console.log(`Making API call to get slots for interviewer ${interviewerId}...`);
      const response = await this.api.post(`/get-slots-by-interviewer`, {
        interviewer_id: interviewerId
      });
      console.log('Get slots by interviewer response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Get slots by interviewer error:', error);
      throw error;
    }
  }

  // Get specific slot details for logged-in user
  async getSpecificSlot() {
    try {
      console.log('Making API call to get specific slot...');
      const response = await this.api.get('/v1/specific-slot');
      console.log('Get specific slot response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Get specific slot error:', error);
      throw error;
    }
  }

  // Select remote slot for assisted recording sessions
  async selectRemoteSlot(slotData) {
    try {
      console.log('Making API call to select remote slot:', slotData);
      const response = await this.api.post('/v1/slot-selection-remote', slotData);
      console.log('Remote slot selection response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Remote slot selection error:', error);
      throw error;
    }
  }
}

export const slotService = new SlotService(); 